import useLocaleText from 'components/useLocaleText'

// New literals required in the configured translation catalogue. Kept beside their UI owner
// so missing translations remain explicit; fallbacks use the actual locale, never layout direction.
export const missingSettingsLiterals = {
  settings: { key: 'task_settings_settings', fallback: { en: 'Task settings', he: 'הגדרות משימה' } },
  view: { key: 'task_settings_view', fallback: { en: 'Folder', he: 'תיקייה' } },
  schedule: { key: 'task_settings_schedule', fallback: { en: 'Schedule', he: 'לוח זמנים' } },
  missing: { key: 'task_settings_missing', fallback: { en: 'Not chosen yet', he: 'טרם נבחר' } },
  set: { key: 'task_settings_set', fallback: { en: 'Set', he: 'הוגדר' } },
  optional: { key: 'task_creation_optional', fallback: { en: 'Optional', he: 'רשות' } },
  check: { key: 'task_settings_check', fallback: { en: 'Check settings', he: 'בדיקת הגדרות' } },
  remaining: { key: 'task_settings_remaining', fallback: { en: 'required left', he: 'שדות חובה נותרו' } },
  previous: { key: 'task_settings_previous', fallback: { en: 'Previous', he: 'הקודם' } },
  empty: { key: 'task_settings_empty', fallback: { en: 'None selected', he: 'לא נבחרו' } },
  changes: {
    key: 'task_settings_changes',
    fallback: {
      en: 'Changes apply as you choose. Done closes this section.',
      he: 'השינויים נשמרים בעת הבחירה. סיום סוגר את הסעיף.',
    },
  },
  ready: { key: 'task_settings_ready', fallback: { en: 'Settings ready', he: 'ההגדרות מוכנות' } },
  readyToPublish: {
    key: 'task_settings_ready_to_publish',
    fallback: { en: 'Ready to publish', he: 'מוכן לפרסום' },
  },
  publishHint: {
    key: 'task_settings_publish_hint',
    fallback: {
      en: 'Subtasks and settings are all set. Pick a setting on the left to change it — or publish now.',
      he: 'תת־המשימות וההגדרות מוכנות. בחרו הגדרה כדי לשנות אותה — או פרסמו עכשיו.',
    },
  },
  choose: {
    key: 'task_settings_choose',
    fallback: { en: 'Choose a setting on the left to review or change it.', he: 'בחרו הגדרה כדי לבדוק או לשנות אותה.' },
  },
  enabled: { key: 'task_settings_enabled', fallback: { en: 'enabled', he: 'פעילים' } },
  busy: { key: 'task_settings_busy', fallback: { en: 'Publishing…', he: 'מפרסם…' } },
} as const

export const settingsLiterals = {
  unselected: { key: 'analytical_others', fallback: { en: 'Others' } },
  back: { key: 'header_button_back', fallback: { en: 'Back to settings', he: 'חזרה להגדרות' } },
  audience: { key: 'create_task_assignee_selected', fallback: { en: 'Choose assignee', he: 'בחירת נמענים' } },
  auditors: { key: 'auditors', fallback: { en: 'Auditors', he: 'מבקרים' } },
  watchers: { key: 'watchers', fallback: { en: 'Watchers', he: 'צופים' } },
  priority: { key: 'priority_header', fallback: { en: 'Priority', he: 'עדיפות' } },
  advanced: { key: 'advanced_options', fallback: { en: 'Advanced options', he: 'אפשרויות מתקדמות' } },
  required: { key: 'required', fallback: { en: 'Required', he: 'חובה' } },
  publish: { key: 'header_button_publish', fallback: { en: 'Publish', he: 'פרסום' } },
  done: { key: 'done', fallback: { en: 'Done', he: 'סיום' } },
  next: { key: 'next', fallback: { en: 'Next', he: 'הבא' } },
  groups: { key: 'post_audience_select_groups', fallback: { en: 'Select groups', he: 'בחירת קבוצות' } },
  users: { key: 'post_audience_select_users', fallback: { en: 'Select users', he: 'בחירת משתמשים' } },
  tags: { key: 'post_audience_select_tags', fallback: { en: 'Select tags', he: 'בחירת תגיות' } },
  selected: { key: 'create_task_post_assignee_selected_text', fallback: { en: 'selected', he: 'נבחרו' } },
  once: { key: 'once', fallback: { en: 'One time', he: 'חד פעמי' } },
  recurring: { key: 't_recurring', fallback: { en: 'Recurring', he: 'חוזר' } },
  clear: { key: 'clear', fallback: { en: 'Clear', he: 'ניקוי' } },
  ...missingSettingsLiterals,
} as const

export const useSettingsText = () => useLocaleText(settingsLiterals)
